<template>
    <div class="customer-dashboard">
        <div class="header-wrapper" id="header-wrapper">
            <div class="container">
                <div class="row">
                    <div class="col-lg-10 col-xl-8">
                        <h1>Hallo{{ displayFirstName ? ' ' + displayFirstName : '' }},</h1>
                        <p v-if="isReservationsPage">Welkom bij je reserveringen.</p>
                        <p v-else>Welkom op je dashboard.</p>
                    </div>
                </div>
            </div>
        </div>


        <div class="container container-wrapper">
            <div class="row">
                <div class="col-md-3">
                    <aut-customer-submenu
                        :items="menuItems"></aut-customer-submenu>
                </div>
                <div class="col-md-9">
                    <div v-if="loading">Laden...</div>
                    <template v-else>
                        <aut-reservation-promo
                            v-if="isReservationsPage"
                            :new-reservation-url="newReservationUrl"
                        ></aut-reservation-promo>

                        <p v-if="!isReservationsPage">Deze persoonlijke pagina biedt je een overzicht van de meest recente activiteiten.
                            Je kunt onder andere reserveringen bekijken en je accountgegevens bewerken.</p>

                        <aut-customer-reservations
                            :reservations="reservations"
                            all-reservations-url="/dashboard/reservations"
                            :new-reservation-url="newReservationUrl"
                        ></aut-customer-reservations>

                        <template v-if="!isReservationsPage">
                            <aut-customer-banner class="mt-4"></aut-customer-banner>
                            <aut-my-location class="mt-4"></aut-my-location>
                        </template>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubMenu from './SubMenu';
import CustomerReservations from './CustomerReservations';
import ReservationPromo from './ReservationPromo';

export default {
    name: 'Dashboard',

    components: {
        'aut-customer-submenu': SubMenu,
        'aut-customer-reservations': CustomerReservations,
        'aut-reservation-promo': ReservationPromo,
    },

    props: {
        firstName: {
            type: String,
            default: '',
        },
        isReservationsPage: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            loading: true,
            reservations: [],
            location: null,
            userData: null,
        };
    },

    computed: {
        menuItems() {
            return [
                { label: 'Mijn Autohopper', url: '/dashboard', active: !this.isReservationsPage, icon: 'car' },
                { label: 'Reserveringen', url: '/dashboard/reservations', active: this.isReservationsPage, icon: 'reservations' },
                { label: 'Accountgegevens', url: '/dashboard/account', active: false, icon: 'account' },
                { label: 'Uitloggen', url: '/user/logout', active: false, icon: 'logout' },
            ];
        },

        newReservationUrl() {
            if (this.location && this.location.path_alias) {
                return this.location.path_alias;
            }
            return '/aanbod';
        },

        displayFirstName() {
            return (this.userData && this.userData.Voornaam) ? this.userData.Voornaam : this.firstName;
        }
    },

    mounted() {
        this.fetchReservations();
        this.fetchLocation();
        this.fetchUserData();
    },

    methods: {
        fetchUserData() {
            window.axios.get('/api/customer/mendix-user-data')
                .then(response => {
                    this.userData = response.data;
                });
        },

        fetchLocation() {
            window.axios.get('/api/customer/my-location')
                .then(response => {
                    this.location = response.data;
                });
        },

        fetchReservations() {
            window.axios.get('/api/customer/reservations')
                .then(response => {
                    this.reservations = response.data;
                    this.loading = false;
                })
                .catch(error => {
                    console.error('Error fetching reservations:', error);
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped>
.customer-dashboard {
    padding: 20px 0;
}
@media (min-width: 992px) {
    .customer-dashboard {
        padding: 40px 0;
    }
}
.header-wrapper {
    padding: 1.5rem 0;
}
@media (min-width: 992px) {
    .header-wrapper {
        padding: 2rem 0;
    }
}
.header-wrapper h1 {
    font-family: Montserrat, sans-serif;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 700;
    line-height: 2.25rem;
}
@media (min-width: 992px) {
    .header-wrapper h1 {
        font-size: 2rem;
        line-height: 3rem;
    }
}
.header-wrapper p {
    font-family: Montserrat, sans-serif;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5rem;
    letter-spacing: -0.72px;
}
@media (min-width: 992px) {
    .header-wrapper p {
        font-size: 1.2rem;
        line-height: 2rem;
    }
}
.container-wrapper {
    padding-top: 1.5rem;
}
@media (min-width: 992px) {
    .container-wrapper {
        padding-top: 2.5rem;
    }
}
.container-wrapper p {
    font-size: 0.8rem;
}
</style>
